/**
 *@format
 */
import { api } from '@/scripts/api';

export const ClientManagementService = {
    getAll({ accountId, config }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${accountId}/requests`;
            const endpoint = api.applyNodeDataParams(service, config);
            api.get(endpoint).then(resolve).catch(reject);
        });
    },

    delete({ accountId, fundRequestId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${accountId}/requests/${fundRequestId}`;
            api.delete(service).then(resolve).catch(reject);
        });
    },
};
